<template>
  <div>
    <div v-if="step==1">
      <button class="btnTest" @click="onFillStep1">TEST1</button>
    </div>
    <div v-else-if="step==2">
      <button class="btnTest" @click="onFillStep2">TEST2</button>
    </div>
    <div v-else>
      <button class="btnTest" @click="onFillStep3">TEST3</button>
    </div>
  </div>
</template>

<style scoped lang="scss">
.btnTest {
  position: absolute;
  top: 100px;
  left: 30px;
}
</style>

<script>
export default {
  name: "EntryTest",
  props: {
    step: Number
  },
  methods: {
    onFillStep1() {
      window.console.log('fill dummy step1')
      var testData = {
        mail: 'k-kotaka@daiichi-g.co.jp',
        //zipCode: '7370814',
        ken: '34',
        schoolFounder: '2',
        //schoolCode: '43400336',
        otherSchoolName: '第一\'高校',
        teacherNameFamily: '古高',
        teacherNameFirst: '克己',
        teacherKanaFamily: 'コタカ',
        teacherKanaFirst: 'カツミ',
        tel1: '082',
        tel2: '２３４',
        tel3: '6816'
      };
      for (let key in testData) {
        this.$store.state.entry[key] = testData[key];
      }
      setTimeout(() => {
        this.$store.state.entry.schoolCode = '43400336'
      }, 1000)
    },
    onFillStep2() {
      window.console.log('fill dummy step2')
      this.$store.state.entry.entrant[0].subject = '40'
      this.$store.state.entry.entrant[0].grade = 'H3'
      this.$store.state.entry.entrant[0].division = '教務主任'
      for (var i = 1, l = this.$store.state.entry.entrant.length; i < l; ++i) {
        this.$store.state.entry.entrant[i].nameFamily = '第一'
        this.$store.state.entry.entrant[i].nameFirst = '太郎'
        this.$store.state.entry.entrant[i].kanaFamily = 'ダイイチ'
        this.$store.state.entry.entrant[i].kanaFirst = 'タロウ'
        this.$store.state.entry.entrant[i].subject = '30'
        this.$store.state.entry.entrant[i].grade = 'H1'
        this.$store.state.entry.entrant[i].division = '教科担当'
      }
    },
    onFillStep3() {
      window.console.log('fill dummy step3')
      var testData = {
        payment: 'bill',
        receipt: '第二高校',
        subject: '30'
      };
      for (let key in testData) {
        this.$store.state.entry[key] = testData[key];
      }
    }
  }
}
</script>